import { BaseService, RequestType, ResponseType } from "@intech/react-service";
import { JsonWebToken } from "../entidades/JsonWebToken";
import { LoginEntidade } from "../entidades/LoginEntidade";

class Usuario extends BaseService {
  constructor() {
    super("Usuario");
  }

  VerificarAdmin = () =>
    this.CreateRequest<boolean>(RequestType.GET, `admin`);

  Menu = () =>
    this.CreateRequest<string[]>(RequestType.GET, `Menu`);

  CriarAcesso = (user: LoginEntidade) =>
    this.CreateRequest<string>(RequestType.POST, `criarAcesso`, user);

  AlterarSenha = (user: LoginEntidade) =>
    this.CreateRequest<string>(RequestType.POST, `alterarSenha`, user);

  AlterarSenhaPrimeiroAcesso = (user: LoginEntidade) =>
    this.CreateRequest<string>(RequestType.POST, `alterarSenhaPrimeiroAcesso`, user);

  BuscarMatriculas = () =>
    this.CreateRequest<string[]>(RequestType.GET, `matriculas`);

  Selecionar = (login: LoginEntidade) =>
    this.CreateRequest<JsonWebToken>(RequestType.POST, `selecionar`, login);

  SelecionarMatricula = (matricula: string, origem: number) =>
    this.CreateRequest<JsonWebToken>(RequestType.POST, `selecionarMatricula/${matricula}/${origem}`);

  Login = (user: LoginEntidade) =>
    this.CreateRequest<any>(RequestType.POST, `login`, user);

  BuscarSituacaoParticipante = (cpf: string) =>
    this.CreateRequest<boolean>(RequestType.GET, `BuscarSituacaoParticipante/${cpf}`);

}

export const UsuarioService = new Usuario();
